module.exports = __webpack_public_path__ + "img/turfy3_fuji.3f48c985.png";